export default "__VITE_ASSET__C5Jo4kuS__"